import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=authenticated
  useEffect(() => {
    const token = localStorage.getItem("erp_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (employee_id, password) => {
    const { data } = await api.post("/auth/login", { employee_id, password });
    localStorage.setItem("erp_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("erp_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const ROLE_LABEL = {
  admin: "Admin / Owner",
  staff_gudang: "Staff Gudang",
  staff_sales: "Staff Sales",
  staff_purchasing: "Staff Purchasing",
  staff_exim: "Staff Ekspor-Impor",
  staff_personalia: "Staff Personalia",
  staff_finance: "Staff Finance",
};

export const canAccess = (role, module) => {
  const map = {
    admin: ["dashboard", "inventory", "purchasing", "sales", "quotations", "invoices", "finance", "expenses", "personalia", "reports", "efaktur", "users", "suppliers", "customers", "settings"],
    staff_gudang: ["dashboard", "inventory", "purchasing", "suppliers"],
    staff_sales: ["dashboard", "sales", "quotations", "invoices", "customers"],
    staff_purchasing: ["dashboard", "purchasing", "suppliers", "inventory"],
    staff_exim: ["dashboard", "purchasing", "suppliers", "invoices", "efaktur"],
    staff_personalia: ["dashboard", "personalia", "expenses"],
    staff_finance: ["dashboard", "finance", "expenses", "invoices", "reports", "efaktur"],
  };
  return (map[role] || []).includes(module);
};
